import * as React from 'react';

import * as _ from 'lodash';
import { connect } from 'react-redux';
import { RouteComponentProps, withRouter } from 'react-router-dom';
import { bindActionCreators, Dispatch } from 'redux';

import { Container } from 'reactstrap';
import { getArticles, clearArticles } from '../actions/article';
import Loading from '../components/Loading';
import Page from '../components/Page';
import Title from '../components/Title';
import { IState } from '../reducers/index';
import text from '../locale';
import Item from './Item';
import IArticle from '../types/models/IArticle';
import ErrorMessage from '../components/ErrorMessage';
import { mpTrackingScreens } from '../config/screens';

interface IPropsFromState {
    articles: IArticle[];
    loading: boolean;
}

interface IPropsFromDispatch {
    getArticles: typeof getArticles;
    clearArticles: typeof clearArticles;
}

class Favourites extends React.Component<IPropsFromState & IPropsFromDispatch & RouteComponentProps> {
    public refresh = () => {
        this.props.getArticles({ favourite: true, disablePremiumOnly: false });
    };

    public renderListOrError = () => {
        const { articles, loading } = this.props;

        if (!loading && _.size(articles) <= 0) {
            return <ErrorMessage message={text.favourites.EMPTY} icon="EMPTY_BOX" />;
        }

        return (
            <Container>
                {articles.map((article, i) => (
                    <Item
                        key={article.id}
                        item={article}
                        refresh={this.refresh}
                        removeGap={articles.length - 1 === i}
                    />
                ))}
            </Container>
        );
    };

    public componentDidMount = () => {
        this.refresh();
    };

    public componentWillUnmount = () => {
        this.props.clearArticles();
    };

    public render() {
        const { loading } = this.props;

        return (
            <Page noCrawl trackingScreen={mpTrackingScreens.library}>
                <Loading loading={loading} />
                <Container>
                    <Title title={text.favourites.TITLE} />
                </Container>
                {this.renderListOrError()}
            </Page>
        );
    }
}

function mapStateToProps(state: IState): IPropsFromState {
    return {
        articles: state.article.articles,
        loading: state.article.loading,
    };
}

function mapDispatchToProps(dispatch: Dispatch): IPropsFromDispatch {
    return bindActionCreators(
        {
            getArticles,
            clearArticles,
        },
        dispatch,
    );
}

export default withRouter(
    connect(
        mapStateToProps,
        mapDispatchToProps,
    )(Favourites),
);
